import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import Navbar from "../../components/common/Navbar";
import { Gauge } from "@mui/x-charts/Gauge";
import {
  LineChart,
  lineElementClasses,
  markElementClasses,
} from "@mui/x-charts/LineChart";
import { PieChart } from "@mui/x-charts/PieChart";
import {
  MonetizationOn as MonetizationOnIcon,
  BarChart as BarChartIcon,
  Receipt as ReceiptIcon,
  ArrowUpward as ArrowUpwardIcon,
} from "@mui/icons-material";
const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
const xLabels = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
function Home() {
  const theme = useTheme();
  const styles = useStyles(theme);

  const location = useLocation();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    // Check if there is a snackbar message passed from the Login page
    if (location.state?.snackbarMessage) {
      setSnackbarMessage(location.state.snackbarMessage);
      setSnackbarSeverity(location.state.snackbarSeverity);
      setSnackbarOpen(true); // Open the snackbar
      // Clear the state after displaying the message
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box sx={styles.db_root}>
      <Navbar />
      {/* Header */}
      <Box sx={styles.db_header}>
        <Typography variant="h2" pb={1} sx={styles.db_headerTitle}>
          Dashboard
        </Typography>
        <Divider />
      </Box>
      <Box sx={{ backgroundColor: "background.default" }}>
        <Grid container spacing={3}>
          {[
            {
              title: "License Package",
              // value: `LKR${calculateTotalSales().toLocaleString()}`,
              subText: "Total Sales for this month",
              icon: <MonetizationOnIcon fontSize="medium" />,
              color: "success.main",
            },
            {
              title: "License Addons",
              // value: `${totalOrders}`,
              subText: "New orders this week",
              icon: <BarChartIcon fontSize="medium" />,
              color: "primary.main",
            },
            {
              title: "User Groups",
              // value: `${totalUsers}`,
              subText: "Returning customers",
              icon: <PeopleIcon fontSize="medium" />,
              color: "error.main",
            },
            {
              title: "Users",
              // value: `${totalUsers}`,
              subText: "Returning customers",
              icon: <PeopleIcon fontSize="medium" />,
              color: "error.main",
            },
          ].map((card, index) => (
            <Grid
              item
              xs={card.title === "Total Sales" ? 12 : 12}
              sm={card.title === "Total Sales" ? 12 : 12}
              md={card.title === "Total Sales" ? 12 : 6}
              lg={card.title === "Total Sales" ? 3 : 3}
              xl={card.title === "Total Sales" ? 3 : 3}
              key={index}
            >
              <Card
                sx={{
                  backgroundColor: "background.paper",
                  boxShadow: 2,
                  borderRadius: 1,
                  padding: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  "&:hover": {
                    boxShadow: 6,
                    transform: "translateY(-2px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  {/* Icon Container */}
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      backgroundColor: card.color,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "12px",
                      color: "white",
                    }}
                  >
                    {card.icon}
                  </Box>
                  {/* Text Content */}
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary", fontWeight: 500 }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ color: "text.primary", fontWeight: "bold" }}
                    >
                      {card.value}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "text.secondary" }}
                    >
                      {card.subText}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/* Main Content */}
      {/* <Box sx={styles.db_mainContent}> */}
      <Grid container mt={2} spacing={4}>
        {/* <Grid item xs={12} sm={6} md={3}>
            <Card sx={styles.db_card}>
              <CardContent>
                <Typography variant="h6">License Package</Typography>
                <Typography variant="h4">$15,000</Typography>
                <Tooltip title="View Sales Analytics" arrow>
                  <IconButton>
                    <AnalyticsIcon />
                  </IconButton>
                </Tooltip>
              </CardContent>
            </Card>
          </Grid> */}
        {/* 
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={styles.db_card}>
              <CardContent>
                <Typography variant="h6">License Addons</Typography>
                <Typography variant="h4">3</Typography>
                <Tooltip title="View Orders" arrow>
                  <IconButton>
                    <ShoppingCartIcon />
                  </IconButton>
                </Tooltip>
              </CardContent>
            </Card>
          </Grid> */}
        {/* 
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={styles.db_card}>
              <CardContent>
                <Typography variant="h6">User Groups</Typography>
                <Typography variant="h4">12</Typography>
                <Tooltip title="View User Stats" arrow>
                  <IconButton>
                    <PeopleIcon />
                  </IconButton>
                </Tooltip>
              </CardContent>
            </Card>
          </Grid> */}

        {/* <Grid item xs={12} sm={6} md={3}>
            <Card sx={styles.db_card}>
              <CardContent>
                <Typography variant="h6">Users</Typography>
                <Typography variant="h4">130</Typography>
                <Tooltip title="View User Stats" arrow>
                  <IconButton>
                    <PeopleIcon />
                  </IconButton>
                </Tooltip>
              </CardContent>
            </Card>
          </Grid> */}

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Card sx={styles.db_card}>
            <CardContent>
              <LineChart
                height={300}
                series={[
                  { data: pData, label: "Actual", id: "pvId" },
                  { data: uData, label: "Average", id: "uvId" },
                ]}
                xAxis={[{ scaleType: "point", data: xLabels }]}
                sx={{
                  [`.${lineElementClasses.root}, .${markElementClasses.root}`]:
                    {
                      strokeWidth: 1,
                    },
                  ".MuiLineElement-series-pvId": {
                    strokeDasharray: "5 5",
                  },
                  ".MuiLineElement-series-uvId": {
                    strokeDasharray: "3 4 5 2",
                  },
                  [`.${markElementClasses.root}:not(.${markElementClasses.highlighted})`]:
                    {
                      fill: "#fff",
                    },
                  [`& .${markElementClasses.highlighted}`]: {
                    stroke: "none",
                  },
                }}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Card sx={styles.db_card}>
            <CardContent>
              <PieChart
                series={[
                  {
                    data: [
                      { id: 0, value: 10, label: "Created Accounts" },
                      { id: 1, value: 15, label: "Available Accounts" },
                      { id: 2, value: 20, label: "Inactive Accounts" },
                    ],
                  },
                ]}
                height={300}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      {/* </Box> */}

      {/* Snackbar for success message from Login */}
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Box>
  );
}

export default Home;
